import { DatePipe } from '@angular/common';
import { Component, OnInit, Type } from '@angular/core';
import { AbstractControl, FormBuilder, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { APICallService } from 'src/app/services/api-call.service';
import { FormService } from 'src/app/services/form.service';
import { JsonDataService } from 'src/app/services/json-data.service';
import { SecurityService } from 'src/app/services/security.service';
import { UserDetailsService } from 'src/app/services/user-details.service';
import { AppMessageService } from 'src/app/services/app-message.service';
import { DialogMsgComponent } from '../../common/dialog-msg/dialog-msg.component';
import { LeaveConfirmation } from '../../common/guard/check.guard';
import { LineLovDialogComponent } from '../../common/line-lov-dialog/line-lov-dialog.component';
import { PerilLovComponent } from '../../common/peril-lov/peril-lov.component';

interface RowData {
    nationality: any
}

@Component({
    selector: 'citizenship-nationality-maintenance',
    templateUrl: './citizenship-nationality-maintenance.html',
    styleUrls: ['./citizenship-nationality-maintenance.css']
})
export class CitizenshipNationalityMaintenanceComponent implements OnInit, LeaveConfirmation {

    moduleId: string = 'BMM048';
    moduleName: string = "";
    formHider: boolean = false;

    constructor(
        private fb: FormBuilder,
        private _matDialog: MatDialog,
        private _api: APICallService,
        public _formService: FormService,
        private _jsonDS: JsonDataService,
        private _securityService: SecurityService,
        private _userDetailService: UserDetailsService,
        private _appMessageService: AppMessageService
    ) {
        this.userIdLoggedIn = this._userDetailService.userId || "";
    }

    ngOnInit(): void {
        this.moduleName = this._jsonDS.data.moduleList.filter((data: any) => { return data.moduleId === this.moduleId })[0].moduleDesc.toUpperCase();
        this.getData.nationality();
    }

    canDeactivate(): boolean | Observable<boolean> {
        return this.tblConfig.nationality.tblData.filter((d: any) => (d.temp === true || d.onDbButUpdatedTemp === true)).length > 0 ? false : true;
    }

    test() {
        console.table(this.forms.nationalityForm.value);
    }

    allowNumericDigitsOnly(event: any) {
        try {
            if (/[0-9.]/.test(String.fromCharCode(event.keyCode))) {
                return true;
            } else {
                event.preventDefault();
                return false;
            }
        } catch (e) {
    console.error(e);
            return undefined;
        }
    }

    /* Boolean Stuffs */

    public btns = {
        nationality: {
            updateDisabled: true,
            deleteDisabled: true,
            saveDisabled: true,
            addDisabled: false,
        }
    }

    public showForm = {
        nationality: true
    }

    /* Data Stuffs */

    private rowData: RowData = {
        nationality: null
    }

    private errorMessage: RowData = {
        nationality: null
    }

    private userIdLoggedIn: string;

    /* Form Object  */

    public forms = {
        nationalityForm: this.fb.group({
            nationalityCd: [''],
            nationalityCdPadded: [{ value: '', disabled: 'true' }],
            activeTag: ['A', [Validators.required]],
            nationalityDesc: ['', [this.checkDuplicateNationalityDesc('nationality'), Validators.maxLength(50), Validators.required]],
            bpimsCd: ['', [Validators.required, Validators.maxLength(8)]],
            bpimsShortDesc: ['', [Validators.required, Validators.maxLength(10)]],
            remarks: ['', [Validators.maxLength(4000)]],
            lastUpdateUser: [{ value: '', disabled: 'true' }],
            lastUpdate: [{ value: '', disabled: 'true' }],
        }),
        resetNationalityForm: () => {
            this.forms.nationalityForm.reset();
            this.forms.nationalityForm.patchValue({
                activeTag: 'A',
            });
            this.btns.nationality.updateDisabled = true;
            this.btns.nationality.deleteDisabled = true;
            this._formService.hideFormMsg("nationality-error-message");
            this.rowData.nationality = null;
        }
    };

    /* Table Object */

    public tblConfig: RowData = {
        nationality: {
            cols: [
                {
                    key: "NATIONALITY_CD_PADDED",
                    header: "Nationality Code",
                    dataType: "string",
                    width: '20%'
                },
                {
                    key: "NATIONALITY_DESC",
                    header: "Nationality",
                    dataType: "string",
                    width: '74%'
                },
                {
                    key: "ACTIVE_TAG",
                    header: "A",
                    dataType: "checkbox",
                    width: '6%'
                },
            ],
            tblData: [],
            selection: "single",
            paginator: true,
            rowsPerPage: 10,
            lazy: false,
            totalRecords: 15,
            loading: false,
        }
    }

    private formManipulation = {
        nationality: {
            dbToForm: function (data: any) {
                return {
                    nationalityCd: (data.NATIONALITY_CD) ? data.NATIONALITY_CD : null,
                    nationalityCdPadded: data.NATIONALITY_CD_PADDED,
                    activeTag: data.ACTIVE_TAG,
                    nationalityDesc: data.NATIONALITY_DESC,
                    bpimsCd: data.BM_CODE,
                    bpimsShortDesc: data.BM_SHORT_DESC,
                    remarks: data.REMARKS,
                    lastUpdateUser: data.USER_ID,
                    lastUpdate: data.LAST_UPDATE
                };
            },
            formToDb: function (data: any) {
                return {
                    NATIONALITY_CD: data.nationalityCd,
                    NATIONALITY_CD_PADDED: (data.nationalityCd) ? data.nationalityCd.toString().padStart(3, 0) : null,
                    ACTIVE_TAG: data.activeTag,
                    NATIONALITY_DESC: data.nationalityDesc,
                    BM_CODE: data.bpimsCd,
                    BM_SHORT_DESC: data.bpimsShortDesc,
                    REMARKS: data.remarks,
                    USER_ID: null,
                    LAST_UPDATE: null
                };
            }
        }
    }

    public selections = {
        activeTypes: [
            { cd: 'A', name: 'Yes' },
            { cd: 'I', name: 'No' },
        ]
    };

    private getData = {
        nationality: () => {
            try {
                this.tblConfig.nationality.tblData = [];
                this.tblConfig.nationality.loading = true;
                this._jsonDS.contorlLoading(true);
                this._api.getNationality({
                    moduleId: this.moduleId,
                    userId: this._userDetailService.userId,
                    type: "MODULE"
                }).subscribe({ 
                    next: (data: any) => {
                        this._securityService.checkRequestKeyResponse(data, () => {
                            this._securityService.hasValidCsrfToken(data, ()=>{
                                try {
                                    if (data.status === 'SUCCESS') {
                                        data = JSON.parse(this._jsonDS.decrypt(data.response));
                                        this._jsonDS.contorlLoading(false);
                                        let filteredData = data.data;
                                        this.tblConfig.nationality.tblData = filteredData;
                                    } else {
                                        this.tblConfig.nationality.loading = false;
                                        this._jsonDS.contorlLoading(false);
                                        this._appMessageService.showAppMessage(data.message, "error");
                                    }
                                } catch (e) {
    console.error(e);
                                }
                                this.tblConfig.nationality.loading = false;
                            });
                        });
                    },
                    error: (e: any) => {
                        this.tblConfig.nationality.loading = false;
                        this._jsonDS.contorlLoading(false);
                    }
                });
            } catch (e) {
    console.error(e);
                this.tblConfig.nationality.loading = false;
                this._jsonDS.contorlLoading(false);
            }
        }
    }

    public onRowClick = {
        nationality: (ev: any) => {
            try {
                ev.update = true;
                this.rowData.nationality = ev;
                this.populateFormFromTable.nationality();
            } catch (e) {
    console.error(e);
                this.forms.resetNationalityForm();
                this.rowData.nationality = null;
            }
        }
    }

    private populateFormFromTable = {
        nationality: () => {
            try {
                let data = this.rowData.nationality;
                this.btns.nationality.updateDisabled = !data.update;
                this.btns.nationality.deleteDisabled = !data.temp;
                this.forms.nationalityForm.patchValue(this.formManipulation.nationality.dbToForm(data));
            } catch (e) {
    console.error(e);
            }
        }
    }

    public onAdd = {
        nationality: () => {
            try {
                this._formService.hideFormMsg("nationality-error-message");
                if (this.forms.nationalityForm.valid && !this.checkRequired()) {
                    let rowToBeAdded: { [key: string]: any } = this.formManipulation.nationality.formToDb(this.forms.nationalityForm.value);
                    rowToBeAdded.temp = true;
                    this.tblConfig.nationality.tblData = [rowToBeAdded, ...this.tblConfig.nationality.tblData];
                    this.forms.resetNationalityForm();
                    this.btns.nationality.saveDisabled = false;
                } else {
                    this.showErrorValidator.nationality();
                }
            }
            catch (e) {
    console.error(e);
            }
        }
    }

    public onDelete = {
        nationality: () => {
            try {
                this.tblConfig.nationality.tblData = this.tblConfig.nationality.tblData.filter((d: any) => {
                    return d !== this.rowData.nationality;
                });
                this.forms.resetNationalityForm();
                let toBeSaved = this.tblConfig.nationality.tblData.filter((d: any) => (d.temp === true || d.onDbButUpdatedTemp === true));
                if (toBeSaved.length === 0) {
                    this.btns.nationality.saveDisabled = true;
                } else {
                    this.btns.nationality.saveDisabled = false;
                }
            } catch (e) {
    console.error(e);
            }
        }
    }

    public onUpdate = {
        nationality: () => {
            try {
                this._formService.hideFormMsg("nationality-error-message");
                if (this.forms.nationalityForm.valid && !this.checkRequired()) {
                    let toBeUpdatedIndex = this.tblConfig.nationality.tblData.indexOf(this.rowData.nationality);
                    let rowToBeUpdated: { [key: string]: any } = this.formManipulation.nationality.formToDb(this.forms.nationalityForm.value);
                    if (this.rowData.nationality.temp) {
                        rowToBeUpdated.temp = true;
                    } else {
                        rowToBeUpdated.onDbButUpdatedTemp = true;
                    }
                    this.forms.resetNationalityForm();
                    this.tblConfig.nationality.tblData[toBeUpdatedIndex] = rowToBeUpdated;
                    this.btns.nationality.saveDisabled = false;
                    this.tblConfig.nationality.tblData = [... this.tblConfig.nationality.tblData];
                } else {
                    this.showErrorValidator.nationality();
                }
            } catch (e) {
    console.error(e);
            }
        }
    }

    public onSave = {
        nationality: () => {
            this.showForm.nationality = false;
            this._formService.showFormLoader(null, "nationality-maintenance-loading", "Saving.<br>Please wait ...", null, null);
            let toBeSaved = this.tblConfig.nationality.tblData.filter((d: any) => (d.temp === true || d.onDbButUpdatedTemp === true));
            if (toBeSaved.length > 0) {
                toBeSaved.map((d: any) => {
                    d.LAST_USER = this.userIdLoggedIn;
                });
                this._api.saveNationality(toBeSaved).subscribe({
                    next: (data: any) => {
                        this._securityService.checkRequestKeyResponse(data, () => {
                            this._securityService.hasValidCsrfToken(data, ()=>{
                                if (data.status === 'SUCCESS') {
                                    this.onComplete.nationality();
                                } else {
                                    this.onComplete.nationalityError();
                                }
                            });
                        });
                    },
                    error: (data: any) => {
                        this.onComplete.nationalityError();
                    }
                });
            } else {
                this.onComplete.nationality();
            }
        }
    }

    openDialog(title: string, contentTitle: string, contentDetail: string) {
        try {
            this._matDialog.open(DialogMsgComponent, {
                disableClose: true,
                width: '512px',
                data: {
                title: title,
                content:
                    title === 'SUCCESS'
                    ? `${contentTitle} details successfully ${contentDetail}!`
                    : `${contentTitle} details ${contentDetail} failed!`,
                },
            });
        } catch (e) {
    console.error(e);
        }
    }

    private onComplete = {
        nationality: () => {
            this.getData.nationality();
            this.btns.nationality.saveDisabled = true;
            this.showForm.nationality = true;
            this._formService.hideFormLoader("nationality-maintenance-loading");
            this.openDialog('SUCCESS', 'Citizenship or Nationality', 'saved');
        },
        nationalityError: () => {
            this.showForm.nationality = true;
            this.btns.nationality.saveDisabled = false;
            this.openDialog('FAILED', 'Citizenship or Nationality', 'saving');
            this._formService.hideFormLoader("nationality-maintenance-loading");
        }
    }

    /* Validator Stuffs Down here */

    checkDuplicateNationalityDesc(module: string): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            const value = control.value === null ? control.value : control.value.trim();
            if (!value) {
                return null;
            }
            let hasDuplicate: boolean = this.tblConfig[module as keyof RowData].tblData.filter((d: any) => {
                if (!this.rowData[module as keyof RowData]) {
                    return d.NATIONALITY_DESC.toLowerCase() === value.toLowerCase();
                } else {
                    return this.rowData[module as keyof RowData].NATIONALITY_DESC.toLowerCase() !== value.toLowerCase() && d.NATIONALITY_DESC.toLowerCase() === value.toLowerCase();
                }
            }).length > 0 ? true : false;
            return hasDuplicate ? { hasDupeNationalityDesc: true } : null;
        }
    }


    /*checkDuplicatePaytDesc(): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            const value = control.value;
            if (!value) {
                return null;
            } 
            let hasDuplicate: boolean = this.tblConfig.srcFunds.tblData.filter((d: any) => {
                if (!this.rowData.srcFunds) {
                    return d.PAYT_DESC === value;
                } else {
                    return this.rowData.srcFunds.PAYT_DESC !== value && d.PAYT_DESC === value;
                }
            }).length > 0 ? true : false;
            return hasDuplicate ? { hasDupePaytDesc: true } : null;
        }
    }

    checkDuplicateSeqNo(module: string): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            const value = control.value;
            if (!value) {
                return null;
            }
            let hasDuplicate: boolean = this.tblConfig[module as keyof RowData].tblData.filter((d: any) => {
                if (!this.rowData[module as keyof RowData]) {
                    return d.SEQ_NO == value;
                } else {
                    return this.rowData[module as keyof RowData].SEQ_NO != value && d.SEQ_NO == value;
                }
            }).length > 0 ? true : false;
            return hasDuplicate ? { hasDupeSeqNo: true } : null;
        }
    }*/
    checkRequired(){
        if(this.forms.nationalityForm.get('nationalityDesc')?.value.trim()=='' || this.forms.nationalityForm.get('nationalityDesc')?.value==null
          ||this.forms.nationalityForm.get('bpimsCd')?.value.trim()=='' || this.forms.nationalityForm.get('bpimsCd')?.value==null
          ||this.forms.nationalityForm.get('bpimsShortDesc')?.value.trim()=='' || this.forms.nationalityForm.get('bpimsShortDesc')?.value==null) {
          return true;
        }else{
          return false;
        }
      }
    public showErrorValidator = {
        nationality: () => {
            try {
                Object.keys(this.forms.nationalityForm.controls).forEach(key => {
                    const controlErrors = this.forms.nationalityForm.get(key)?.errors;
                    if (controlErrors != null) {
                        Object.keys(controlErrors).forEach(keyError => {
                            if (keyError == 'required' && controlErrors[keyError] === true){
                                this.errorMessage.nationality = "There are missing information. Please provide necessary information needed.";
                            } else if (keyError == 'hasDupeNationalityDesc' && controlErrors[keyError] === true) {
                                this.errorMessage.nationality = "Nationality already exists. Please add a unique Nationality.";
                            }
                        });
                    }
                });
                if(this.checkRequired()){
                    this.errorMessage.nationality = "There are missing information. Please provide necessary information needed.";
                }
                this._formService.showFormMsg("nationality-error-message", this.errorMessage.nationality, "E");
            } catch (e) {
    console.error(e);
            }
        }
    }
}
